import React from "react";
import { TextComponent } from "./TextComponent"; // Adjust the path as necessary
import { FormSectionElements } from "../../entities/formTemplateDataType";
import FormValidationUtils from "../../utilities/FormValidationUtils";
import { getRootComponent } from "../../utilities/ElementUtils";
import { LiveValidationErrMsg } from "../live-validation-errMsg/LiveValidationErrMsg";
import XMLParser from "../../utilities/XMLParser";

interface Props {
    field: FormSectionElements;
    editable: boolean;
    title;
    labelControlArray;
    requiredField;
    callbackElement;
    isEng: boolean;
  }
  
  interface State {
  
  }

export class NumberComponent extends TextComponent {
  private lastVisible?: boolean;
  private currentVisible: boolean = true;

  constructor(props: Props) {
    super(props);
    const field = this.props.field;
    field.IsDirty = false;
  }

  onBlur = (e) => {
    let field = this.props.field;

    FormValidationUtils.validateNumber(field);

    if (field.Valid) {
      FormValidationUtils.runJavascript(field);
    }

    this.props.callbackElement(getRootComponent(field));
  };

  onKeyDown = (e) => {
    if (e.key === "e" || e.key === "E" || e.key === "+" || e.key === "-") {
      e.preventDefault();
    }
  };

  onTextEditChange = (e) => {
    let field = this.props.field;
    let elem = e.originalEvent ? e.originalEvent.target : e.target;
    let val = elem.value;
    // Only allow digits and decimal point
    val = val.replace(/[^0-9.]/g, "");

    if (field?.doNotAllowTrailingZeros && val?.length > 1) {
      val = val.replace(/^0+(?=\d)/, "");
    }

    if (val !== '') {
      const num = parseInt(val, 10);
      if (!isNaN(num)) {
        if (field.MaxValue != null && num > field.MaxValue) return;
        if (field.MinValue != null && num < field.MinValue) return;
      }
    }

    field.Value = val;

    FormValidationUtils.markFieldDirty(field);
    FormValidationUtils.runKeyStrokeJavascript(field);

    this.props.callbackElement(getRootComponent(this.props.field));
  };

  componentDidUpdate() {
    if (this.props.field.FilterField != null && this.lastVisible !== this.currentVisible) {
      this.lastVisible = this.currentVisible;

      // ⚠️ legacy mutation (allowed ONLY here)
      this.props.field.Visible = this.currentVisible;

      this.props.callbackElement(
        getRootComponent(this.props.field)
      );
    }
  }

  render() {
    let field = this.props.field;
    let editable = this.props.editable;
    let labelControlArray = this.props.labelControlArray;
    let requiredField = this.props.requiredField;
    let title = this.props.title;

    let isVisible = field.Visible ?? true;
    if (field.FilterField != null) {
        const foundFilterField = field.findFieldByName(field.FilterField);
        if (foundFilterField != null) {
            isVisible = foundFilterField.Value === field.FilterValue;
        }
    }
    this.currentVisible = isVisible;

    if (!isVisible) {
      return null;
    }

    const programContainer = getRootComponent(field);

    let controlArray = [];

    if (editable) {
      controlArray.push(
        <div
          key={"div_number_" + field.Id}
          style={{ textAlign: "left", marginRight: "1rem" }}
        >
          <div key={"fdLbl_div_" + field.Id}>{labelControlArray}</div>
          <div key={'fdIpt_div_' + field.Id} >
            <div>
            {!getRootComponent(field).ErrorBottom&&(<LiveValidationErrMsg
              field={this.props.field}
              isEng={this.props.isEng}
              key={"LiveValidationErrMsg_" + field.LoadBindName}
              id={`${field.LoadBindName}-${field.Id}`}
            />)}
                <input
                  className={
                    field.Valid || !field.Touched
                      ? "ontario-input"
                      : "ontario-input ontario-input__error"
                  }
                  style= {{ ...(field.LengthInPixel && { width: `${field.LengthInPixel}px` })}}
                  id={field.LoadBindName}
                  key={"fdIpt_number_" + field.Id}
                  type="number"
                  value={field.Value || ""}
                  onChange={this.onTextEditChange}
                  onBlur={this.onBlur}
                  onKeyDown={this.onKeyDown}
                  min={field.MinValue ?? undefined}
                  max={field.MaxValue ?? undefined}
                  disabled={!editable}
                  required={requiredField}
                  readOnly={field.ReadOnly}
                />
              {getRootComponent(field).ErrorBottom&&(<LiveValidationErrMsg
              field={this.props.field}
              isEng={this.props.isEng}
              key={"LiveValidationErrMsg_" + field.LoadBindName}
              id={`${field.LoadBindName}-${field.Id}`}
            />)}
            </div>
          </div>
        </div>
      );
    } else {
      controlArray.push(
        <div className={programContainer.isHorizontalLayout ? 'pdf-row-column' : 'pdf-two-column'} key={"pdf_number_" + field.Id}>
          <div>{title}</div>
          <div>{field.Value}</div>
        </div>
      );
    }

    return controlArray;
  }
}
